export enum TopNavigationView {
    BALANCE = 'balance',
    PROFILE = 'profile',
    CLOSED = 'closed',
}
